const suppliers = {
  toast: {
    error: {
      badResponse: '[Fleet] resposta incorreta do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fleet] foi criado com sucesso',
      },
      edit: {},
    },
  },
  create: {
    successToast: {
      message: 'Sucesso! Frota criada!',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar a frota',
    },
  },

  edit: {
    successToast: {
      message: 'Sucesso! Frota atualizada!',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar a frota',
    },
  },

  deleteModal: {
    header: 'Excluir frotas',
    body: 'Você está prestes a excluir {{num}} frotas.',
  },

  deleteToast: 'Não é possível excluir as frotas',

  forms: {
    information: {
      rank: {
        header: 'Classificação e pontuação da frota',
      },
      supplierKpis: {
        header: 'KPIs da frota',
      },
    },
  },
  delete: {
    confirmation: {
      header: 'Confirmação de exclusão da frota',
      body: 'As frotas foram excluídas com sucesso',
    },
  },
};

export default suppliers;
